import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router'; // Importa Router per il reindirizzamento
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Recupera il token dal servizio Auth
    const token = this.authService.getToken();

    let clonedRequest = req;

    // Se il token esiste, aggiungilo nell'header della richiesta
    if (token) {
      clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    // Passa la richiesta al prossimo handler
    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          // Se il token è scaduto o non valido, rimuovi il token
          this.authService.removeToken(); // Rimuovi il token dal servizio Auth

          // Reindirizza l'utente alla pagina di login
          window.location.href = environment.login;
        }
        return throwError(() => error); // Rilancia l'errore per altre gestioni
      })
    );
  }
}
